import { Brain, Cloud, Sparkles, MessageSquare, Eye, Layers, Cpu, Cog, PenTool, Video } from "lucide-react";

// --- Previous Web UI Images ---
import dicciUI from "../assets/web ui/dicci ui.jpg";
import greenfuelUI from "../assets/web ui/greenfuel ui.jpg";
import mothersonUI from "../assets/web ui/motherson ui.jpg";
import sagarConUI from "../assets/web ui/sagar_con ui.jpg";

// --- New Web UI Images ---
import desitalkUI from "../assets/web ui/desitalk/desitalk.jpg";
import personalFinancialUI from "../assets/web ui/personal_financial/personal finance.jpg";
import wahBhaiWahUI from "../assets/web ui/wah-bhai-wah/image.png";
import zexonUI from "../assets/web ui/zexon/image.png";
import urbanCareUI from "../assets/web ui/urban-care/image.png";

// --- Previous App UI Images ---
import dicciAppPic1 from "../assets/app ui/dicci/pic1.jpeg";
import dicciAppPic2 from "../assets/app ui/dicci/pic2.jpeg";
import dicciAppPic3 from "../assets/app ui/dicci/pic3.jpeg";
import dicciAppPic4 from "../assets/app ui/dicci/pic4.jpeg";

import hemantraAppPic1 from "../assets/app ui/hemantra/pic1.jpeg";
import hemantraAppPic2 from "../assets/app ui/hemantra/pic2.jpeg";
import hemantraAppPic3 from "../assets/app ui/hemantra/pic3.jpeg";
import hemantraAppPic4 from "../assets/app ui/hemantra/pic4.jpeg";

import mothersonAppPic0 from "../assets/app ui/motherson/pic0.jpeg";
import mothersonAppPic1 from "../assets/app ui/motherson/pic1.jpeg";
import mothersonAppPic2 from "../assets/app ui/motherson/pic2.jpeg";
import mothersonAppPic3 from "../assets/app ui/motherson/pic3.jpeg";

// --- New App UI Images ---
import sec1 from "../assets/app ui/securex/image.png";
import sec2 from "../assets/app ui/securex/image copy.png";

import she1 from "../assets/app ui/sheapp/image.png";
import she2 from "../assets/app ui/sheapp/image copy.png";

import urbanCare1 from "../assets/app ui/urban-care/image 1.jpeg";
import urbanCare2 from "../assets/app ui/urban-care/image 2.jpeg";
import urbanCare3 from "../assets/app ui/urban-care/image 3.jpeg";

export const companyProjects = [
  // Previous Projects (Top)
  {
    title: "DICCI Search Portal",
    desc: "A focused portal built to help users quickly search and discover relevant business opportunities and information.",
    image: dicciUI,
    url: "https://dicci-search-portal.vercel.app/",
  },
  {
    title: "Greenfuel Technology",
    desc: "Corporate website presenting clean energy offerings, technology capabilities, and sustainability-driven initiatives.",
    image: greenfuelUI,
    url: "https://greenfueltechnology.in/",
  },
  {
    title: "Motherson Enterprise",
    desc: "Business profile platform highlighting enterprise services, capabilities, and company presence for clients and partners.",
    image: mothersonUI,
    url: "https://mothersonenterprise.com/",
  },
  {
    title: "Sagar Consultancy",
    desc: "Professional services website showcasing consultancy offerings, domain expertise, and contact pathways.",
    image: sagarConUI,
    url: "https://sagarconsultancy.in/",
  },
  // New Projects
  {
    title: "DesiTalk Chat App",
    desc: "Real-time communication platform built with WebSockets, featuring instant messaging, media sharing, and group interactions.",
    image: desitalkUI,
    url: "https://desitak.vercel.app/",
  },
  {
    title: "Personal Portfolio & Finance",
    desc: "A comprehensive tool for tracking personal wealth, expenses, and investment performance with visual insights.",
    image: personalFinancialUI,
    url: "https://personal-finance-manage-hazel.vercel.app/",
  },
  {
    title: "Wah Bhai Wah",
    desc: "A modern restaurant and food ordering website with engaging visuals, clear menu discovery, and a conversion-focused ordering journey.",
    image: wahBhaiWahUI,
    url: "https://wah-bhai-wah.vercel.app/",
  },
  {
    title: "Zexon Pest Control",
    desc: "Service business website crafted for pest control lead generation, featuring trust-building service sections, coverage details, and strong call-to-action flow.",
    image: zexonUI,
    url: "https://zexon-pest-control.vercel.app/",
  },
  {
    title: "Urban Care | Home Services",
    desc: "Professional home services website for booking trusted professionals for cleaning, repair, and maintenance needs.",
    image: urbanCareUI,
    url: "https://urbancare-frontend-2.onrender.com/",
  },
];

export const allProjects = [
  { title: "Smart AI Assistant", desc: "Real-time AI-powered conversational assistant providing instant responses to customer inquiries.", tech: "LLM Engine \u2022 OpenAI GPT \u2022 Session Management", category: "Generative AI" },
  { title: "Form Filling Assistant Chatbot", desc: "Intelligent chatbot guiding users through complex form filling with precision and accuracy.", tech: "LLM Engine \u2022 OpenAI GPT \u2022 Session Management", category: "Generative AI" },
  { title: "Knowledge Base Chatbot", desc: "AI chatbot providing information from organization's knowledge base with rule-based validation.", tech: "LLM Engine \u2022 OpenAI GPT \u2022 Rule-based Validation", category: "Generative AI" },
  { title: "Automated Report Generation", desc: "Generates precise reports from meeting transcripts and recorded sessions automatically.", tech: "RAG \u2022 Entity Extraction \u2022 Azure Doc Intelligence", category: "NLP" },
  { title: "Intelligent Text Summarization", desc: "Produces concise, accurate summaries of complex documents and business communications.", tech: "OpenAI GPT \u2022 Chain-of-Prompts", category: "NLP" },
  { title: "Document Q&A System", desc: "Interactive AI-powered question-answering system for specific documents.", tech: "RAG \u2022 OpenAI GPT", category: "Generative AI" },
  { title: "Intelligent Document Extraction", desc: "Automatically extracts relevant information from PDFs, images, and scanned files.", tech: "RAG \u2022 Azure Document Intelligence", category: "Machine Learning" },
  { title: "Document Anomaly Detection", desc: "Identifies anomalies and inconsistencies in business documents automatically.", tech: "Vision LLM \u2022 Azure Document Intelligence", category: "Computer Vision" },
  { title: "Natural Language to SQL Converter", desc: "Converts plain English queries into precise SQL statements.", tech: "NLP to SQL \u2022 Chain-of-Prompts", category: "NLP" },
  { title: "Database Insights Generator", desc: "Extracts meaningful insights from SQL databases using AI-driven analysis.", tech: "NLP to SQL \u2022 Chain-of-Prompts", category: "Machine Learning" },
  { title: "Image Analysis & Description Agent", desc: "Vision-based AI agent that analyzes and describes images, charts, and visual content.", tech: "Vision LLM \u2022 Azure Document Intelligence", category: "Computer Vision" },
  { title: "Decision Support Agent", desc: "Sophisticated AI system analyzing data for data-driven recommendations.", tech: "OpenAI GPT \u2022 Entity Extraction", category: "Machine Learning" },
  { title: "Smart Matching & Recommendation", desc: "AI-driven recommendation system matching requirements with optimal resources.", tech: "LLM Engine \u2022 Entity Extraction", category: "Machine Learning" },
  { title: "Content Builder Assistant", desc: "AI-powered tool guiding users through creating business content step-by-step.", tech: "Fine-tuned Models \u2022 OpenAI GPT", category: "Generative AI" },
  { title: "Automated Scheduling System", desc: "Intelligent scheduling creating optimal schedules based on constraints.", tech: "RAG \u2022 Entity Extraction", category: "Integration" },
];

export const androidApps = [
  // Previous Apps (Top)
  {
    title: "DICCI Android App",
    desc: "Business-focused Android app built for real-time access to DICCI services and updates.",
    images: [dicciAppPic1, dicciAppPic2, dicciAppPic3, dicciAppPic4],
    features: [
      "Real-time access to DICCI business network and events.",
      "Instant notifications for member updates and news.",
      "Integrated search for member directory and business opportunities.",
    ],
    apkUrl: "#",
  },
  {
    title: "Hemantra Android App",
    desc: "Field-ready Android app experience designed for fast navigation and streamlined user tasks.",
    images: [hemantraAppPic1, hemantraAppPic2, hemantraAppPic3, hemantraAppPic4],
    features: [
      "Optimized for field operations with offline capabilities.",
      "Fast entry system for data collection and reporting.",
      "Native Android performance with smooth animations.",
    ],
    apkUrl: "#",
  },
  {
    title: "Motherson Android App",
    desc: "Enterprise Android app interface with clear workflows for day-to-day business operations.",
    images: [mothersonAppPic0, mothersonAppPic1, mothersonAppPic2, mothersonAppPic3],
    features: [
      "Comprehensive enterprise dashboard for operational tracking.",
      "Secure authentication and data encryption for business safety.",
      "Integrated workflow management for team collaboration.",
    ],
    apkUrl: "#",
  },
  // New Apps
  {
    title: "SecureX | Enterprise-Grade Privacy",
    desc: "Engineered a security-first application featuring AES-256 encrypted vaults and biometric authentication.",
    images: [sec1, sec2],
    features: [
      "Engineered a security-first application featuring AES-256 encrypted vaults and biometric authentication.",
      "Supports hidden media storage, encrypted note-taking, and secure file sharing.",
      "Focused on zero-knowledge architecture to guarantee absolute user privacy.",
    ],
    apkUrl: "#",
  },
  {
    title: "SheGuardian | Emergency Response System",
    desc: "Created a mission-critical safety application with one-tap SOS and real-time GPS location sharing.",
    images: [she1, she2],
    features: [
      "Created a mission-critical safety application with one-tap SOS and real-time GPS location sharing.",
      "Integrates automated SMS alerts and background audio recording during emergency triggers.",
      "Designed specifically for women safety with a focus on reliability in low-connectivity environments.",
    ],
    apkUrl: "#",
  },
  {
    title: "Urban Care | Home Services App",
    desc: "On-demand home services app designed to connect users with trusted professionals for daily maintenance and repair needs.",
    images: [urbanCare1, urbanCare2, urbanCare3],
    features: [
      "Streamlined booking flow for cleaning, repair, and maintenance services.",
      "Service request tracking with clear status updates from booking to completion.",
      "Mobile-first UI focused on fast navigation, clear categories, and trust signals.",
    ],
    apkUrl: "#",
  },
];

export const categories = ["All Projects", "Generative AI", "Machine Learning", "NLP", "Computer Vision", "Integration"];

export const metrics = [
  { value: "95%", label: "Client Satisfaction Rate" },
  { value: "40%", label: "Average Efficiency Gain" },
  { value: "99.5%", label: "System Accuracy" },
  { value: "30%", label: "Average Cost Reduction" },
  { value: "100%", label: "On-Time Delivery" },
];

export const coreServices = [
  {
    icon: Brain,
    title: "AI & Machine Learning",
    items: [
      "Custom AI Model Development",
      "Predictive Analytics",
      "Computer Vision Solutions",
      "Natural Language Processing",
    ],
    color: "#7C4DFF",
  },
  {
    icon: Sparkles,
    title: "Generative AI",
    items: [
      "LLM Integration & Fine-tuning",
      "RAG System Implementation",
      "Content Generation Systems",
      "Conversational AI",
    ],
    color: "#27B8FF",
  },
  {
    icon: Cloud,
    title: "Cloud & Integration",
    items: [
      "Cloud Infrastructure Setup",
      "API Development",
      "System Integration",
      "DevOps for AI",
    ],
    color: "#A78BFA",
  },
];

export const featuredProjects = [
  {
    category: "Banking",
    title: "Intelligent Document Processing",
    desc: "AI-powered system for automated financial document analysis and compliance checking.",
  },
  {
    category: "Healthcare",
    title: "Medical Data Analysis Platform",
    desc: "Machine learning platform for predictive analytics in patient diagnosis and treatment.",
  },
  {
    category: "Retail",
    title: "Smart Inventory Management",
    desc: "AI-driven inventory optimization and demand forecasting for retail chains.",
  },
];

export const coreTech = [
  {
    icon: Sparkles,
    title: "Generative AI Solutions",
    color: "#7C4DFF",
    items: [
      "Custom LLM Development: Fine-tuned models for specific domains",
      "RAG Systems: Retrieval-Augmented Generation for accurate responses",
      "Content Generation: Automated content creation and optimization",
      "Code Generation: AI-powered coding assistants",
      "Chatbot Development: Intelligent conversational interfaces",
    ],
  },
  {
    icon: Brain,
    title: "Machine Learning",
    color: "#27B8FF",
    items: [
      "Predictive Analytics: Forecast trends and behaviors",
      "Custom ML Models: Tailored algorithms for specific use cases",
      "Anomaly Detection: Identify outliers and unusual patterns",
      "Recommendation Systems: Personalized suggestions",
      "Time Series Analysis: Predictive modeling for sequential data",
    ],
  },
  {
    icon: MessageSquare,
    title: "Natural Language Processing",
    color: "#A78BFA",
    items: [
      "Text Classification: Categorize and organize text data",
      "Sentiment Analysis: Extract emotions and opinions",
      "Entity Recognition: Identify and extract key information",
      "Document Intelligence: Automated document processing",
      "Language Translation: Multilingual text processing",
    ],
  },
  {
    icon: PenTool,
    title: "AI Content & Copywriting",
    color: "#F59E0B",
    items: [
      "AI Content Writing: Long-form blogs, articles & reports",
      "AI Copywriting: High-converting ad copies & sales pages",
      "SEO-Optimized Content: Rank higher with AI-driven writing",
      "Brand Voice Training: Fine-tuned models for consistent tone",
      "Multi-language Content: Generate content in 50+ languages",
    ],
  },
  {
    icon: Video,
    title: "AI Video Production",
    color: "#EF4444",
    items: [
      "AI Video Editing: Automated cuts, transitions & enhancements",
      "Script-to-Video: Convert scripts into polished video content",
      "AI Voice & Avatar: Realistic AI voiceovers and presenters",
      "Short-form Reels: Auto-generate social media video clips",
    ],
  },
];

export const advancedCapabilities = [
  {
    icon: Eye,
    tag: "Computer Vision",
    title: "Vision & Image AI",
    desc: "Advanced computer vision solutions including object detection, image classification, facial recognition, and visual search.",
    items: ["Object Detection & Tracking", "Image Segmentation", "OCR & Document Scanning", "Quality Inspection Systems"],
    color: "#EC4899",
  },
  {
    icon: Layers,
    tag: "AI Integration",
    title: "AI System Integration",
    desc: "Seamless integration of AI solutions into existing enterprise systems, workflows, and business processes.",
    items: ["API Development & Integration", "Legacy System Modernization", "Cloud Migration for AI", "Real-time Data Processing"],
    color: "#7C4DFF",
  },
  {
    icon: Cpu,
    tag: "AI Analytics",
    title: "AI-Powered Analytics",
    desc: "Transform raw data into actionable insights with advanced analytics platforms powered by machine learning.",
    items: ["Business Intelligence Dashboards", "Predictive Maintenance", "Customer Behavior Analytics", "Operational Efficiency Analysis"],
    color: "#10B981",
  },
  {
    icon: PenTool,
    tag: "AI Content",
    title: "AI Content Writing",
    desc: "Generate high-quality, SEO-optimized content at scale — blogs, articles, product descriptions, and brand storytelling powered by advanced AI.",
    items: ["Long-form Blogs & Articles", "SEO-Optimized Web Copy", "Product Descriptions at Scale", "Brand Storytelling & Ghostwriting"],
    color: "#F59E0B",
  },
  {
    icon: PenTool,
    tag: "AI Copywriting",
    title: "AI Copywriting",
    desc: "Craft persuasive, conversion-focused copy for ads, landing pages, emails, and sales funnels using AI trained on high-performing copy.",
    items: ["Ad Copy & Campaign Messaging", "Landing Page & Sales Copy", "Email Marketing Sequences", "Social Media & Headline Writing"],
    color: "#F97316",
  },
  {
    icon: Video,
    tag: "Video Editing",
    title: "AI Video Editing",
    desc: "Automated, professional-grade video editing powered by AI — from raw footage to polished final cuts with smart transitions, color grading, and audio sync.",
    items: ["Smart Auto-Editing & Cuts", "Color Grading & Enhancement", "Subtitle & Caption Generation", "Short-form Reels & Clips"],
    color: "#EF4444",
  },
];

export const processStepsData = [
  { num: "01", title: "Discovery & Assessment", desc: "Comprehensive analysis of business needs, data infrastructure, and technical requirements.", color: "#7C4DFF" },
  { num: "02", title: "Solution Design", desc: "Detailed solution architecture, selecting the right technologies and approaches.", color: "#27B8FF" },
  { num: "03", title: "Development & Testing", desc: "Develop, train, and test AI models ensuring accuracy, reliability, and performance.", color: "#A78BFA" },
  { num: "04", title: "Deployment & Support", desc: "Complete deployment with ongoing maintenance, monitoring, and optimization.", color: "#10B981" },
];

export const techPartners = [
  { title: "Cloud Platforms", items: "AWS \u2022 Microsoft Azure \u2022 Google Cloud", icon: Cloud },
  { title: "AI Frameworks", items: "TensorFlow \u2022 PyTorch \u2022 OpenAI \u2022 Hugging Face", icon: Brain },
  { title: "Development Tools", items: "Docker \u2022 Kubernetes \u2022 Git \u2022 CI/CD", icon: Cog },
];

export const industryApplications = [
  { title: "Finance & Banking", desc: "Fraud detection, risk assessment, automated document processing." },
  { title: "Healthcare", desc: "Medical image analysis, patient diagnosis support, drug discovery." },
  { title: "Retail & E-commerce", desc: "Personalized recommendations, inventory optimization, sentiment analysis." },
  { title: "Manufacturing", desc: "Predictive maintenance, quality control, supply chain optimization." },
];
